import { Component } from 'react';
import PropTypes from 'prop-types';

import Config from '../../Util/config';
import HttpUtil from '../../Util/httpUtil';
import Cookies from 'js-cookie';

class ValidarLogin extends Component {
	constructor(props) {
		super(props);

		console.log('id', this.props.params.idUsuario);

		let retornoCookie = this.getCookie('bG9naW4');

		console.log('retornoCookie', retornoCookie);

		//Cookies.set('bG9naW4', 'id', { secure: true, sameSite: 'None' });
		let cookieTeste = Cookies.get('bG9naW4');
		console.log('cookie teste', cookieTeste);

		if (this.props.params.simular != undefined && this.props.params.simular == "true") {

			this.state = {
				idUsuario: this.props.params.idUsuario,
			};
			this.logar();
		} else {
			let cookie = Cookies.get('bG9naW4');
			if(cookie != undefined && cookie != "") {
				cookie = atob(cookie);
				cookie = JSON.parse(cookie);
				this.state = {
					idUsuario: (this.props.params.idUsuario == '39000') ? this.props.params.idUsuario : cookie.id,
					isDemonstrativo: cookie.demonstrativo,
				};
				this.logar();
			}
			else {
				window.location = 'https://www.econeteditora.com.br/user/ver_log.asp?Pag=http://gnre.econeteditora.com.br/validar-login';
			}
		}
	}

	getCookie(name) {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);

		if (parts.length === 2) {
			var teste = parts.pop().split(';').shift();
			console.log('teste cokko tobias', teste);
			return teste;
		}
	}

	logar = () => {
		//const cookie = cookies.get('bG9naW4');
		//var codAcesso = this.state.isDemonstrativo ? '39000' : this.state.idUsuario;
		var codAcesso = this.state.idUsuario;
		console.log('caiu no logar');
		var url = `${Config.urls.API_URL_BASE}Acesso/ValidarDadosLogin/${codAcesso}`;
		// var urlReferrer = document.referrer;
		return new Promise(() => {
			HttpUtil.eco_GET(url)
				.then(response => {
					console.log("Entrou!")
					if (!response.data) {
						window.location = '/erro';
					} else {
						localStorage.setItem('CodUsuario', response.data.CodUsuario);
						localStorage.setItem('NomeUsuario', response.data.NomeUsuario);
						localStorage.setItem('AccessToken', response.data.accessToken);
						localStorage.setItem('PrimeiroAcesso', response.data.PrimeiroAcesso);
						localStorage.setItem('Administrador', response.data.Administrador);
						localStorage.setItem('isSimulacao', response.data.isSimulacao);
						localStorage.setItem('isPro', response.data.isPro);
						localStorage.setItem('Token', '');

						// eslint-disable-next-line eqeqeq
						if (response.data.isPro && response.data.CodUsuario == '39000') {
							window.location = '/validar-token';
						} else window.location = '/';
					}
				})
				.catch((err) => {
					console.log("Erro", err)
					window.location = '/erro';
				});
		});
	};

	render() {
		return null;
	}
}

ValidarLogin.propTypes = {
	params: PropTypes.object,
};

export default ValidarLogin;
